import React from 'react';
import { LikesFragment } from './likes.graphql';
import { Mutation } from '@apollo/client/react/components';

import likeMutation, { likeMutation as likeMutationData, likeMutationVariables } from './like.graphql';
import unlikeMutation, { unlikeMutation as unlikeMutationData, unlikeMutationVariables } from './unlike.graphql';

import Button from './button/button';

export interface Props extends LikesFragment {}

class Likes extends React.PureComponent<Props> {
    render() {
        const { photoBlog } = this.props;

        return photoBlog ? (
            <Mutation<likeMutationData, likeMutationVariables> mutation={likeMutation}>
                {like => (
                    <Mutation<unlikeMutationData, unlikeMutationVariables> mutation={unlikeMutation}>
                        {unlike => {
                            const { id, likesCount, isLikedByViewer } = photoBlog;

                            return isLikedByViewer !== null ? (
                                <Button
                                    isLikedByViewer={isLikedByViewer}
                                    likesCount={likesCount}
                                    onClick={
                                        isLikedByViewer
                                            ? () => {
                                                  unlike({
                                                      variables: { id },
                                                      optimisticResponse: {
                                                          unlikePhotoBlog: {
                                                              photoBlog: {
                                                                  likesCount: photoBlog.likesCount! - 1,
                                                                  isLikedByViewer: false,
                                                                  id,
                                                                  __typename: 'PhotoBlogNode',
                                                              },
                                                              __typename: 'UnlikePhotoBlogPayload',
                                                          },
                                                      },
                                                  });
                                              }
                                            : () => {
                                                  like({
                                                      variables: { id },
                                                      optimisticResponse: {
                                                          likePhotoBlog: {
                                                              photoBlog: {
                                                                  likesCount: (photoBlog.likesCount || 0) + 1,
                                                                  isLikedByViewer: true,
                                                                  id,
                                                                  __typename: 'PhotoBlogNode',
                                                              },
                                                              __typename: 'LikePhotoBlogPayload',
                                                          },
                                                      },
                                                  });
                                              }
                                    }
                                />
                            ) : null;
                        }}
                    </Mutation>
                )}
            </Mutation>
        ) : null;
    }
}

export default Likes;
